import React, { ComponentProps } from "react";
import { FormControlLabel, FormControlLabelProps, Switch, SxProps, Theme } from "@mui/material";

export interface ISwitchWithLabelProps extends Omit<FormControlLabelProps, "onChange" | "control"> {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    size?: ComponentProps<typeof Switch>["size"];
    fontSize?: keyof Theme["typography"];
    sx?: SxProps<Theme>;
}

export const SwitchWithLabel: React.FC<ISwitchWithLabelProps> = ({ checked, onChange, label, size = "medium", fontSize, sx, disabled = false }) => {
    return (
        <FormControlLabel
            control={<Switch size={size} onChange={onChange} />}
            checked={checked}
            disabled={disabled}
            label={label}
            sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "auto",
                mx: 0,
                ...sx,
            }}
            slotProps={{
                typography: {
                    sx: {
                        mb: 0,
                        ml: [0, 1],
                        marginInlineEnd: 3,
                        fontWeight: "inherit",
                        fontSize,
                    },
                },
            }}
        />
    );
};
